export enum EPeriodDetail {
    fiveMinutes = '5',
    thirtyMinutes = '30',
    oneHour = '60',
    twoHours = '120',
    fourHours = '240',
    today = 'today',
}
